import { Editor } from '@tiptap/core';

export type TaskDeletionInfo = {
    isLastTask: boolean;
};

/**
 * Deletes the task item at the given position, along with any nested sub-tasks.
 *
 * If the task is the last remaining top-level task, the document is left unchanged and the
 * callback is invoked with `isLastTask: true` so the consumer can decide how to handle it.
 */
export const deleteTaskItem = (
    editor: Editor,
    position: number,
    onDeleteTask?: (info: TaskDeletionInfo) => void,
): void => {
    const taskItem = editor.state.doc.nodeAt(position);

    if (!taskItem) return;

    const $position = editor.state.doc.resolve(position);
    const isOnlyChildOfList = $position.parent.childCount === 1;
    const isLastTask = $position.depth === 1 && isOnlyChildOfList;

    if (!isLastTask) {
        // Deleting the only child of a nested list would leave an empty taskList, which the
        // schema forbids — remove the wrapping list instead.
        const from = isOnlyChildOfList ? $position.before() : position;
        const to = isOnlyChildOfList ? $position.after() : position + taskItem.nodeSize;

        editor.commands.deleteRange({ from, to });
    }

    onDeleteTask?.({ isLastTask });
};
